import styled, { css } from 'styled-components';

// Constellation Components
import {
    spaceMixin,
    Text,
    Toast,
    token,
} from '@zillow/constellation';

import {
    Link,
    Notification,
} from '@zillow/zrs-comet';

export const StyledActivationErrorStickyDiv = styled.div`
    ${props => props.theme.ns().media.lg(css`
        display: none;
    `)};

    .Activation-Error-Box {
        padding: ${spaceMixin('xs')} 0 ${spaceMixin('xs')} 0;
        z-index: 1000;
        background-color: ${token('colors.red400')};
        color: white;
        text-align: center;
        width: 100%;
    }

    .sticky-Activation-Error-Box {
        padding: ${spaceMixin('xs')} 0 ${spaceMixin('xs')} 0;
        z-index: 1000;
        background-color: ${token('colors.red400')};
        color: white;
        text-align: center;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
    }
`;

export const StyledActivationErrorToastDiv = styled.div`
    display: none;

    ${props => props.theme.ns().media.lg(css`
        display: block;
    `)};
`;

export const StyledEditListingPageDiv = styled.div`
    padding: 0 0 ${spaceMixin('xs')};

    .Container {
        max-width: 100%;
    }

    .EditListingPage-photo-upload-instructions {
        margin-top: ${spaceMixin('xs')};
        margin-bottom: ${spaceMixin('md')};
    }

    .EditListingPage-Container {
        ${props => props.theme.ns().media.lg(css`
            padding: 0 ${spaceMixin('md')};
        `)};
    }
`;

export const StyledLink = styled(Link)`
    &&{
        color: ${token('colors.white')};
    }
`;

export const StyledMainContentDiv = styled.div`
    width: 100%;
`;

export const StyledNotification = styled(Notification)`
    position: fixed;
    top: 0;
    left: 0;
    height: auto;
    opacity: 0;
    z-index: 1000;
    pointer-events: none;

    &.Notification-opacity {
        opacity: 1;
        transition: opacity 0.2s ease-in, background 0.4s ease-out;
    }

    &.Notification-done {
        opacity: 0;
        transition: opacity 0.5s 1s ease-in, background 0.4s ease-out;
    }

    ${props => props.theme.ns().media.lg(css`
        /* always fade out */
        &.Notification-opacity {
            opacity: 0;
        }
    `)};
`;

export const StyledNotificationLink = styled(Link)`
    &&{
        color: ${token('colors.white')};
        text-decoration: underline;
    }
`;

export const StyledToast = styled(Toast)`
    bottom: ${spaceMixin('25')};
    position: fixed;
    right: 50px;
    z-index: 1000;
`;

export const StyledNotificationToastContainerDiv = styled.div`
    ${StyledToast} {
        bottom: ${spaceMixin('14')};
    }

    .Toast-Base {
        opacity: 0;

        ${props => props.theme.ns().media.lg(css`
            opacity: 1;
        `)};

        &.Toast-Wrapper-hidden {
            opacity: 0;
            transition: opacity 0.5s 1.0s ease-in, background .4s ease-out;
        }
    }
`;

export const StyledPostingFormContainer = styled.div`
    position: relative;

    ${props => props.theme.ns().media.lg(css`
        min-height: 400px;
    `)};
`;

export const StyledPostingFormDiv = styled.div`
    position: relative;

    ${props => props.theme.ns().media.lg(css`
        min-height: 400px;
    `)};
`;


export const StyledText = styled(Text)`
    font-weight: normal;
`;

export const StyledBlockText = styled(Text)`
    display: inline-block;
`;

export const StyledWhiteText = styled(Text)`
    > a {
        color: white;
        font-weight: 600;
    }
`;
